import { createStructuredSelector } from 'reselect';

import {
  routesSelector,
  routeSelectedSelector,
  isRoutesFetchingSelector,
} from '@store/selectors/routesSelector';

export const structuredSelector = createStructuredSelector({
  routes: routesSelector,
  routeSelected: routeSelectedSelector,
  isRoutesFetching: isRoutesFetchingSelector,
});
